import { useTracking } from './useTracking'
import { type BasePlausibleEvent } from './types'

type AddressSelectTrackingEvent = Omit<BasePlausibleEvent, 'type'> & {
  interaction: 'Manual' | 'Autocomplete'
}

type AddressSelectTrack = (event: AddressSelectTrackingEvent) => void

export function useAddressSelectTracking(): AddressSelectTrack {
  const track = useTracking()

  return (event) => {
    track({
      type: 'Address_Selection',
      props: {
        interaction: event.interaction,
      },
      callback: event.callback,
    })
  }
}
